export const mergeColumnStateAndDef = (baseColDef, savedColDef) => {
        if (!baseColDef) return null;
        // Merge base column definition with saved column definition properties
        return savedColDef ? { ...baseColDef, ...savedColDef } : baseColDef;
    }